import axiosClient from '../axios-client';

/* Dashboard + sidebar badge data. These are polled and decorative-adjacent, so they
   resolve to safe empty values rather than throwing and blanking the shell. */

export const getAttentionCounts = async () =>
  axiosClient
    .get('/dashboard/attention')
    .then((res) => res?.data || {})
    .catch(() => ({}));

export const getDashboardSummary = async (days = 30) =>
  axiosClient
    .get(`/dashboard/summary?days=${days}`)
    .then((res) => res?.data || { kpis: [] })
    .catch(() => ({ kpis: [] }));

export const getTodaysSessions = async (limit = 8) =>
  axiosClient
    .get(`/dashboard/todays-sessions?limit=${limit}`)
    .then((res) => res?.data || [])
    .catch(() => []);

export const getActivityFeed = async (limit = 12) =>
  axiosClient
    .get(`/dashboard/activity?limit=${limit}`)
    .then((res) => res?.data || [])
    .catch(() => []);
